import { render, staticRenderFns } from "./ROExpeditionSchema.vue?vue&type=template&id=bf86364e&"
import script from "./ROExpeditionSchema.vue?vue&type=script&lang=js&"
export * from "./ROExpeditionSchema.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports